import React, { useEffect, useState } from "react";
import { FaUserGroup, FaRotateRight } from "react-icons/fa6";
import { spotifyApi } from "../services/spotify";
import { listFanOrders } from "../lib/fanProfile";
import type { ForYouResponse, Track } from "../types/spotify";
import "./ForYouShelves.css";
import { t } from "../i18n";

// "For you" (founder, 1.5.1 #14 — and a core part of the fan side from here
// on): two swipeable shelves above Trending, built from OUR request data, not
// Spotify's (its personal recommendations are closed to apps our size).
//   Popular at <DJ>  — what this DJ's crowd requests
//   Request again    — this fan's own past requests (this phone's history,
//                      or the account's when signed in — the server decides)
// A shelf with nothing in it doesn't render; no data at all → nothing, and
// Trending carries the page exactly as before.
const ForYouShelves: React.FC<{ djSlug?: string; djName?: string; onPick: (track: Track) => void }> = ({ djSlug, djName, onPick }) => {
  const [data, setData] = useState<ForYouResponse | null>(null);

  useEffect(() => {
    if (!djSlug) return;
    let alive = true;
    const orders = listFanOrders()
      .sort((a, b) => b.ts - a.ts)
      .slice(0, 20)
      .map((o) => o.id);
    spotifyApi
      .forYou(djSlug, orders)
      .then((res) => {
        if (alive) setData(res);
      })
      .catch(() => {
        if (alive) setData(null);
      });
    return () => {
      alive = false;
    };
  }, [djSlug]);

  if (!data) return null;
  const shelves = [
    {
      key: "popular",
      icon: <FaUserGroup size={15} aria-hidden />,
      // Topped up with what's trending (few requests here yet): "Popular now" (1.5.2 b49).
      title: data.popularLabel === "now" ? t("forYou.popularNow") : t("forYou.popularAt", { name: djName || "" }),
      tracks: data.popularHere,
    },
    { key: "again", icon: <FaRotateRight size={14} aria-hidden />, title: t("forYou.requestAgain"), tracks: data.requestAgain },
  ].filter((s) => Array.isArray(s.tracks) && s.tracks.length > 0);
  if (!shelves.length) return null;

  return (
    <div className="fy">
      {shelves.map((s) => (
        <section key={s.key} className="fy-shelf">
          <div className="rq-feed-heading">
            {s.icon}
            <span>{s.title}</span>
          </div>
          <div className="fy-row">
            {s.tracks.map((tr) => (
              <button key={tr.id} type="button" className="fy-tile" onClick={() => onPick(tr)}>
                <img src={tr.image} alt="" loading="lazy" />
                <span className="fy-name">{tr.name}</span>
                <span className="fy-artist">{tr.artists.map((a) => a.name).join(", ")}</span>
              </button>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
};

export default ForYouShelves;
